<template>
  <div>
    <create-new-folder
      :data-to-show="isCreateFolderPopupDisplayed"
      :parent-folder="path[path.length - 1].id"
      :errors="errorsCreateNewFolder"
      @showChange="
        (val) => {
          displayPopupAddNewFolder(val);
        }
      "
      @createNewFolder="
        (folder) => {
          createFolder(folder);
        }
      "
    />

    <edit-folder
      :data-to-show="isEditFolderPopupDisplayed"
      :errors="errorsEditFolder"
      :folder="folderToEdit"
      @showChange="
        (val) => {
          displayPopupEditFolder(val);
        }
      "
      @editFolder="
        (folderEdited) => {
          editFolder(folderEdited);
        }
      "
    />

    <delete-folder
      :data-to-show="isDeleteFolderPopupDisplayed"
      :errors="errorsDeleteFolder"
      :folder="folderToDelete"
      @close="displayPopupDeleteFolder(false)"
      @deleteFolder="deleteFolder()"
    />

    <move-folder
      :data-to-show="isMoveFilePopupDisplayed"
      :file-to-move="fileToMove"
      :errors="errorsMoveFile"
      @showChange="
        (val) => {
          displayPopupMoveFile(val);
        }
      "
      @moveFile="
        (file) => {
          moveFile(file);
        }
      "
    />

    <add-member
      :data-to-show="isAddMemberPopupDisplayed"
      :errors="errorsAddMemberFolder"
      :folder="folderToShare"
      @showChange="
        (val) => {
          displayPopupAddMember(val);
        }
      "
      @addMembers="
        (members) => {
          addMembers(members);
        }
      "
      @editUserRights="
        (user, newRights) => {
          editUserRights(user, newRights);
        }
      "
      @editRoleRights="
        (role, newRights) => {
          editRoleRights(role, newRights);
        }
      "
      @revokeUserRights="
        (user) => {
          revokeUserRights(user);
        }
      "
      @revokeRoleRights="
        (role) => {
          revokeRoleRights(role);
        }
      "
    />

    <add-new-file
      :data-to-show="stateAddFilePopup"
      @showChange="
        (val) => {
          changeStatePopupAddNewFile(val);
        }
      "
      :loading="addNewFileLoading"
      @addTempFile="
        (data) => {
          addTempFile(data);
        }
      "
      @addFile="
        (infos) => {
          addFile(infos);
        }
      "
      :file-temp="fileTemp"
      :current-folder="path[path.length - 1].id"
      :errors="errorsAddNewFile"
    />

    <edit-file
      :data-to-show="isEditFilePopupDisplayed"
      :errors="errorsEditFile"
      :file="fileToEdit"
      @showChange="
        (val) => {
          displayPopupEditFile(val);
        }
      "
      @editFile="
        (fileEdited) => {
          editFile(fileEdited);
        }
      "
    />

    <preview-file
      :data-to-show="isPreviewPopupDisplayed"
      @close="displayPopupPreview(false)"
      :file="fileToDisplay"
    />

    <div class="px-12">
      <div class="flex">
        <h4 class="text-left">
          <span class="text-indigo-600 cursor-pointer" @click="goToPath()">
            {{
              path.length == 1 && Object.keys(path[0]).length == 0
                ? 'Tous les dossiers'
                : 'Dossiers'
            }}
          </span>
          <span
            v-for="(p, i) in path.filter((p) => Object.keys(p).length > 0)"
            :key="i"
            @click="goToPath(i)"
            class="text-gray-600 cursor-pointer"
          >
            > {{ p.name }}</span
          >
        </h4>
      </div>

      <div class="relative w-max">
        <div class="my-10">
          <add-button
            v-if="
              (Object.keys(path[path.length - 1]).length == 0 ||
                $editFile(path[path.length - 1], currentPage)) &&
              canEdit &&
              $can(constants.PERMISSION_DEPOT_DOCUMENTS_CREATE)
            "
            libelle="Ajouter un nouveau dossier ou fichier"
            :with-dropdown="true"
            @add="displayDropdownAddNewFolderOrFile"
          />
        </div>

        <div
          v-if="isDropdownCreateFolderOrFileDisplay"
          class="absolute z-10 right-0 top-8 px-5 py-3 bg-white shadow rounded-xl text-sm"
          v-click-outside="displayDropdownAddNewFolderOrFile"
        >
          <div class="flex flex-col space-y-1.5 text-gray-600">
            <p
              class="hover:text-gray-900 cursor-pointer"
              @click.stop="displayPopupAddNewFolder(true)"
            >
              Nouveau dossier
            </p>
            <p
              class="hover:text-gray-900 cursor-pointer"
              @click.stop="changeStatePopupAddNewFile(1)"
            >
              Nouveau fichier
            </p>
          </div>
        </div>
      </div>

      <div
        :class="
          'grid grid-cols-3 gap-12 ' +
          (currentFolders.length > 0 ? 'mb-12' : '')
        "
      >
        <div
          v-for="(folder, numFolder) in currentFolders"
          :key="numFolder"
          class="col-span-full md:col-span-1"
        >
          <folder-card
            :editable="$editFile(folder, currentPage) && canEdit"
            :is-admin="$adminFile(folder, currentPage)"
            :is-owner="$ownerFile(folder, currentPage)"
            :in-neopass-form="currentPage.includes('/form/neopass/')"
            :folder="folder"
            :folders="folders"
            :files="files"
            :smaller="currentPage.includes('/form/neopass/')"
            @openFolder="openFolder(folder)"
            @editFolder="displayPopupEditFolder(true, folder)"
            @downloadFolder="downloadAFolder(folder)"
            @deleteFolder="displayPopupDeleteFolder(true, folder)"
            @moveFolder="displayPopupMoveFile(true, folder)"
            @addMember="displayPopupAddMember(true, folder)"
          />
        </div>
      </div>
      <div class="grid grid-cols-3 gap-12">
        <div
          v-for="(file, numFile) in currentFiles"
          :key="numFile"
          class="col-span-full md:col-span-1"
        >
          <file-card
            :file="file"
            @openFile="displayPopupPreview(true, file)"
            @downloadFile="downloadAFile(file)"
            @moveFile="displayPopupMoveFile(true, file)"
            @addMember="displayPopupAddMember(true, file)"
            @editFile="displayPopupEditFile(true, file)"
            @deleteFile="displayPopupDeleteFolder(true, file)"
            :editable="$editFile(file, currentPage) && canEdit"
            :is-admin="$adminFile(file, currentPage)"
            :is-owner="$ownerFile(file, currentPage)"
            :in-neopass-form="currentPage.includes('/form/neopass/')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import AddButton from './../../components/Inputs/AddButton';
import FolderCard from './../../components/DepotDocuments/FolderCard';
import FileCard from './../../components/DepotDocuments/FileCard';

import CreateNewFolder from './popup/CreateNewFolder.vue';
import EditFolder from './popup/EditFolder.vue';
import DeleteFolder from './popup/DeleteFolder.vue';
import MoveFolder from './popup/MoveFolder.vue';
import AddMember from './popup/AddMember';
import AddNewFile from './popup/AddNewFile.vue';
import PreviewFile from './popup/PreviewFile.vue';
import EditFile from './popup/EditFile.vue';

import ClickOutside from 'vue-click-outside';
import JsFileDownload from 'js-file-download';

import Constants from './../../constants';

export default {
  name: 'CurrentFolder',

  components: {
    AddButton,
    FolderCard,
    FileCard,
    CreateNewFolder,
    EditFolder,
    DeleteFolder,
    MoveFolder,
    AddMember,
    AddNewFile,
    PreviewFile,
    JsFileDownload,
    EditFile,
  },

  props: {
    files: {
      type: Array,
      required: false,
      default: [],
    },

    folders: {
      type: Array,
      required: false,
      default: [],
    },

    path: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      isDropdownCreateFolderOrFileDisplay: false,

      hasAllFiles: false,

      isCreateFolderPopupDisplayed: false,
      errorsCreateNewFolder: {},

      isEditFolderPopupDisplayed: false,
      folderToEdit: {},
      errorsEditFolder: {},

      isDeleteFolderPopupDisplayed: false,
      folderToDelete: {},
      errorsDeleteFolder: {},

      isMoveFilePopupDisplayed: false,
      fileToMove: {},
      errorsMoveFile: {},

      isAddMemberPopupDisplayed: false,
      folderToShare: {},
      errorsAddMemberFolder: {},

      stateAddFilePopup: -1,
      fileTemp: {
        id: null,
        path: '',
        finalPath: '',
        name: '',
      },
      errorsAddNewFile: {},
      addNewFileLoading: false,

      isPreviewPopupDisplayed: false,
      fileToDisplay: {},

      isEditFilePopupDisplayed: false,
      errorsEditFile: {},
      fileToEdit: {},

      constants: Constants,
    };
  },

  mounted() {
    //
  },

  methods: {
    ...mapActions({
      createNewFolder: 'depotDocuments/createNewFolder',
      editCurrentFolder: 'depotDocuments/editCurrentFolder',
      deleteCurrentFolder: 'depotDocuments/deleteCurrentFolder',
      moveTheFile: 'depotDocuments/moveTheFile',
      shareFolderWithUsers: 'depotDocuments/shareFolderWithUsers',
      shareFolderWithRoles: 'depotDocuments/shareFolderWithMembers',
      editRightsUser: 'depotDocuments/editRightsUsers',
      editRightsRole: 'depotDocuments/editRightsRoles',
      removeUsers: 'depotDocuments/removeUsers',
      removeRoles: 'depotDocuments/removeRoles',
      loadFiles: 'depotDocuments/loadFiles',
      addNewTempFile: 'depotDocuments/addNewTempFile',
      addNewFile: 'depotDocuments/addNewFile',
      downloadFolder: 'depotDocuments/downloadFolder',
      downloadFile: 'depotDocuments/downloadFile',
      editCurrentFile: 'depotDocuments/editCurrentFile',
    }),

    ...mapMutations({
      setMessageHeader: 'depotDocuments/SET_MESSAGEHEADER',
    }),

    openFolder(folder = null) {
      this.$emit('openFolder', folder == null ? {} : folder);
    },

    displayDropdownAddNewFolderOrFile() {
      this.isDropdownCreateFolderOrFileDisplay =
        !this.isDropdownCreateFolderOrFileDisplay;
    },

    displayPopupAddNewFolder(state) {
      this.isDropdownCreateFolderOrFileDisplay = false;
      this.isCreateFolderPopupDisplayed = state;
      this.errorsCreateNewFolder = {};
    },

    displayPopupAddNewFile(state) {
      this.isDropdownCreateFolderOrFileDisplay = false;
    },

    displayPopupEditFolder(state, folder = null) {
      if (folder) {
        this.folderToEdit = { ...folder };
      }
      this.isEditFolderPopupDisplayed = state;
      this.errorsEditFolder = {};
    },

    displayPopupEditFile(state, file = null) {
      if (file) {
        this.fileToEdit = { ...file };
      }
      this.isEditFilePopupDisplayed = state;
      this.errorsEditFile = {};
    },

    displayPopupDeleteFolder(state, folder = null) {
      if (folder) {
        this.folderToDelete = { ...folder };
      }
      this.isDeleteFolderPopupDisplayed = state;
      this.errorsDeleteFolder = {};
    },

    displayPopupMoveFile(state, file = null) {
      if (file) {
        this.fileToMove = { ...file };
      }
      this.isMoveFilePopupDisplayed = state;
      this.errorsMoveFile = {};
    },

    displayPopupAddMember(state, folder = null) {
      if (folder) {
        this.folderToShare = folder;
      }
      this.isAddMemberPopupDisplayed = state;
      this.errorsAddMemberFolder = {};
    },

    changeStatePopupAddNewFile(state) {
      this.stateAddFilePopup = state;
      this.errorsAddNewFile = {};
      this.addNewFileLoading = false;
    },

    displayPopupPreview(state, file = null) {
      if (file) {
        this.fileToDisplay = { ...file };
      }
      this.isPreviewPopupDisplayed = state;
    },

    async createFolder(folder) {
      try {
        await this.createNewFolder(folder).then((response) => {
          this.isCreateFolderPopupDisplayed = false;
          this.errorsCreateNewFolder = {};
        });
      } catch (err) {
        this.errorsCreateNewFolder = err;
      }
    },

    async editFolder(folder) {
      try {
        await this.editCurrentFolder([this.folderToEdit.id, folder]).then(
          (response) => {
            this.isEditFolderPopupDisplayed = false;
            this.errorsEditFolder = {};
            this.folderToEdit = {};
          }
        );
      } catch (err) {
        this.errorsEditFolder = err;
      }
    },

    async editFile(file) {
      try {
        console.log('current folder file', file);
        await this.editCurrentFile([this.fileToEdit.id, file]).then(
          (response) => {
            this.isEditFilePopupDisplayed = false;
            this.errorsEditFile = {};
            this.fileToEdit = {};
          }
        );
      } catch (err) {
        this.errorsEditFile = err;
      }
    },

    async deleteFolder() {
      try {
        await this.deleteCurrentFolder(this.folderToDelete).then((response) => {
          this.isDeleteFolderPopupDisplayed = false;
          this.folderToDelete = {};
        });
      } catch (err) {
        this.errorsDeleteFolder = err;
      }
    },

    async moveFile(file) {
      try {
        await this.moveTheFile({
          source: this.fileToMove,
          destination: file,
        }).then((response) => {
          this.isMoveFilePopupDisplayed = false;
          this.fileToMove = {};
        });
      } catch (err) {
        this.errorsMoveFile = err;
      }
    },

    async downloadAFolder(folder) {
      try {
        await this.downloadFolder(folder).then((response) => {
          JsFileDownload(response.data, folder.name + '.zip');
        });
      } catch (err) {
        //
      }
    },

    async downloadAFile(file) {
      try {
        await this.downloadFile(file).then((response) => {
          JsFileDownload(response.data, file.name);
        });
      } catch (err) {
        //
      }
    },

    async addMembers(members) {
      let responses = { users: 200, roles: 200 };
      if (members.users.length > 0) {
        try {
          responses.users = 0;
          await this.shareFolderWithUsers({
            folder: this.folderToShare,
            users: members.users,
          }).then((response) => {
            responses.users = response.status;
          });
        } catch (error) {
          console.error(error);
          this.errorsAddMemberFolder = error;
        }
      }

      if (members.roles.length > 0) {
        try {
          responses.roles = 0;
          await this.shareFolderWithRoles({
            folder: this.folderToShare,
            roles: members.roles,
          }).then((response) => {
            responses.roles = response.status;
          });
        } catch (error) {
          console.error(error);
          this.errorsAddMemberFolder = error;
        }
      }

      if (responses.users == 200 && responses.roles == 200) {
        let successMessage =
          this.folderToShare.type == 'folder'
            ? 'Le dossier a été partagé avec succès.'
            : 'Le fichier a été partagé avec succès.';
        this.setMessageHeader({ type: 'success', msg: successMessage });
        setTimeout(() => {
          this.setMessageHeader(null);
        }, 3000);
        await this.loadFiles().then((response) => {
          this.updateFolderToShare();
        });
      }
    },

    async editUserRights(user, newRights) {
      try {
        await this.editRightsUser({
          users: [user],
          newRights: newRights,
          folder: this.folderToShare,
        }).then((response) => {
          this.updateFolderToShare();
        });
      } catch (error) {
        console.error(error);
        this.errorsAddMemberFolder = error;
      }
    },

    async editRoleRights(role, newRights) {
      try {
        await this.editRightsRole({
          roles: [role],
          newRights: newRights,
          folder: this.folderToShare,
        }).then((response) => {
          this.updateFolderToShare();
        });
      } catch (error) {
        console.error(error);
        this.errorsAddMemberFolder = error;
      }
    },

    async revokeUserRights(user) {
      try {
        await this.removeUsers({
          folder: this.folderToShare,
          users: [user],
        }).then((response) => {
          this.updateFolderToShare();
        });
      } catch (error) {
        console.error(error);
        this.errorsAddMemberFolder = error;
      }
    },

    async revokeRoleRights(role) {
      try {
        await this.removeRoles({
          folder: this.folderToShare,
          roles: [role],
        }).then((response) => {
          this.updateFolderToShare();
        });
      } catch (error) {
        console.error(error);
        this.errorsAddMemberFolder = error;
      }
    },

    updateFolderToShare() {
      console.log('update folder');
      this.folderToShare =
        this.folders.filter(
          (folder) => folder.id == this.folderToShare.id
        )[0] ||
        this.files.filter((file) => file.id == this.folderToShare.id)[0];
    },

    async addTempFile(data) {
      try {
        this.addNewFileLoading = true;
        await this.addNewTempFile(data).then((response) => {
          //the API returns the temporary path of the file
          this.fileTemp.path = response;
          this.fileTemp.finalPath = response.replace(
            'tmp/' + this.user.id + '/',
            ''
          );
          this.stateAddFilePopup = 2;
          this.addNewFileLoading = false;
        });
      } catch (err) {
        this.errorsAddNewFile = err;
        this.addNewFileLoading = false;
      }
    },

    async addFile(infos) {
      try {
        await this.addNewFile(infos).then((response) => {
          this.stateAddFilePopup = -1;
        });
      } catch (err) {
        this.errorsAddNewFile = err;
      }
    },

    goToPath(path = null) {
      this.$emit('goto', path);
    },
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),

    listIdsFolder: {
      get: function () {
        return this.folders.map((f) => f.id);
      },
    },

    currentFolders: {
      get: function () {
        return this.folders.filter(
          (f) =>
            f.folder_id == this.path[this.path.length - 1].id ||
            (Object.keys(this.path[this.path.length - 1]).length == 0 &&
              (f.folder_id == null ||
                !this.listIdsFolder.includes(f.folder_id)))
        );
      },
    },

    currentFiles: {
      get: function () {
        return this.files.filter(
          (f) => f.folder_id == this.path[this.path.length - 1].id
        );
      },
    },

    currentPage() {
      return this.$route.path;
    },

    canEdit() {
      let userId = this.currentPage.includes('/form/neopass/')
        ? parseInt(this.currentPage.split('/form/neopass/')[1].split('/')[0])
        : this.user.id;

      return (
        !this.currentPage.includes('/form/neopass/') ||
        this.$can('documents_edit', userId)
      );
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>
